import { useMemo } from "react";
import { useIntl } from "react-intl";
import {
  CustomAttributeFilterProps,
  SpotlightOption,
  SpotlightsFilter as SharedSpotlightsFilter,
} from "@knowfully/ui.common";

const COLOR_META_NAME = "Color";

export default function SpotlightsFilter({
  group,
  value,
  onChange,
}: CustomAttributeFilterProps) {
  const { formatMessage: t } = useIntl();

  const options: SpotlightOption[] = useMemo(
    () =>
      group.options
        .filter((o) => !!o.label)
        .map((o) => ({
          id: o.id,
          label: o.label,
          hex: o.metaValues?.find(
            (m) => m.name.toLowerCase() === COLOR_META_NAME.toLowerCase()
          )?.value,
        })),
    [group.options]
  );

  return (
    <SharedSpotlightsFilter
      options={options}
      value={value}
      onChange={onChange}
      showLabel={t({ id: "show" })}
    />
  );
}
